import { useState } from 'react';
import { Box, IconButton, Tooltip, CircularProgress } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useUserPinQuery } from '../../api/JsdhNotifikaceService/service/AdminMutations';

interface PinRevealCellProps {
    userId: number;
    hasPin: boolean;
}

/**
 * HO-113: PIN se nikdy nenačítá plošně. Zobrazí se až po kliknutí na oko
 * (per-row fetch přes admin-gated reveal endpoint). Opakovaný klik skryje.
 */
export const PinRevealCell = ({ userId, hasPin }: PinRevealCellProps) => {
    const [revealed, setRevealed] = useState(false);
    const { data, isFetching } = useUserPinQuery(userId, revealed);

    if (!hasPin) return <>–</>;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
            {/* BE vrací pin: "" (ne null), když PIN mezitím zmizel — proto || a ne ?? */}
            <span>{revealed ? (isFetching ? '…' : (data?.pin || '–')) : '••••'}</span>
            <Tooltip title={revealed ? 'Skrýt PIN' : 'Zobrazit PIN'}>
                <IconButton
                    size="small"
                    aria-label={revealed ? 'Skrýt PIN' : 'Zobrazit PIN'}
                    onClick={(e) => {
                        e.stopPropagation();
                        setRevealed((v) => !v);
                    }}
                >
                    {isFetching ? (
                        <CircularProgress size={16} />
                    ) : revealed ? (
                        <VisibilityOffIcon fontSize="small" />
                    ) : (
                        <VisibilityIcon fontSize="small" />
                    )}
                </IconButton>
            </Tooltip>
        </Box>
    );
};
